/* eslint-disable consistent-return */
import safeParse from './safeParse';
import isServerSideRendering from './isServerSideRendering';

/**
 * Retrieves and parses a given cookie value by name. Encoded URI component
 * strings will be decoded and JSON strings will be parsed into actual JSON,
 * and numeric strings will be parsed as Numbers.
 */
function getCookie(key: string) {
  if (isServerSideRendering()) return;
  const cookie = document.cookie
    .split('; ')
    .map(c => c.split('='))
    .find(c => c[0] === key);

  if (!cookie || cookie[1] === undefined) return undefined;

  const val = decodeURIComponent(cookie[1]);
  if (!Number.isNaN(Number(val))) {
    return Number(val);
  }

  return safeParse(val) || val;
}

export default getCookie;
